import { FC, InputHTMLAttributes, ReactNode, useRef } from 'react'
import { RadioContainer, RadioContent } from './styles'

interface ImgRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  children: ReactNode;
  label?: string;
}

const ImgRadio: FC<ImgRadioProps> = ({ children, checked, label, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const onRadioClick = () => {
    if(!!inputRef && !!inputRef.current) inputRef.current.click()
  }
  
  return (
    <RadioContainer checked={!!checked} onClick={() => onRadioClick()}>
      <div className='ball'/>
      <input ref={inputRef} {...rest} checked={checked} type="radio"/>
      <RadioContent checked={!!checked}>
        <div>
          {children}
        </div>
        <span>{label}</span>
      </RadioContent>
    </RadioContainer>
  )
}

export default ImgRadio